// extracted by mini-css-extract-plugin
export default {"flash":"sales-offer-table-renderers_flash__3SxeG"};